import { FC, useEffect, useState } from "react";
import { Box, MainContainer } from "../../../styles/basicStyles";
import { BarContainer } from "./styles";
import Typography from "../../../components/typography";

interface InfobarProps {
  tabBarTitleColor: string;
  tabBarSubtitleColor: string;
  bgColorDesktop: string;
  titleDetail: string;
  subtitle: string;
}

const InfoBar: FC<InfobarProps> = ({
  tabBarTitleColor,
  tabBarSubtitleColor,
  bgColorDesktop,
  titleDetail,
  subtitle,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const onScroll = () => {
      if(window.scrollY > 580) setVisible(true);
      else setVisible(false);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <BarContainer
      opacity={visible ? 1 : 0}
      background={bgColorDesktop}
      fAlign="center"
      fJustify="center"
    >
      <MainContainer>
        <Box fAlign="center" fWrap="wrap">
          <Typography
            fSize={{ md: 1.375, xxs: 1.125 }}
            lHeight={{ md: 2, xxs: 1.75 }}
            fWeight={700}
            mr={{ md: 1.875, xxs: 1.25 }}
            color={tabBarTitleColor}
          >
            {titleDetail}
          </Typography>
          <Typography
            fSize={{ md: 0.938, xxs: 0.875 }}
            lHeight={{ md: 1.125, xxs: 1.063 }}
            fWeight={400}
            maxW={31.25}
            color={tabBarSubtitleColor}
          >
            {subtitle}
          </Typography>
        </Box>
      </MainContainer>
    </BarContainer>
  );
};

export default InfoBar;
